<template>
  <div class="um-card-body">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'CardBody'
}
</script>



// WEBPACK FOOTER //
// src/components/card/card-body.vue